import { Component, EventEmitter, Input, OnInit, Output, ViewChild, NgZone, ElementRef } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyService } from '../../service/company.service';
import { AuthorizationService } from '../../service/authorizationService';
import { NbAutocompleteDirective, NbAutocompleteModule, NbInputDirective, NbTagInputDirective } from '@nebular/theme';

@Component({
  selector: 'filter-service-provider-company',
  templateUrl: './filter-service-provider-company.component.html',
  styleUrls: ['./filter-service-provider-company.component.css']
})
export class FilterServiceProviderCompanyComponent implements OnInit {
  //@ViewChild('autoInput') input: ElementRef<HTMLInputElement>;
  @ViewChild(NbInputDirective, { read: ElementRef }) autoInput: ElementRef<HTMLInputElement>;
  @Input() spcValue: string = '';
  @Output() spcSelected: EventEmitter<any> = new EventEmitter();
  public optServiceProviderCompany: string[];
  filteredOptions$: Observable<string[]>;

  
  constructor(
    private authorizationService: AuthorizationService,
  ) { }

  ngOnInit(): void {
    console.log(this.spcValue)
    this.authorizationService.getAllServiceProviderCompany().subscribe((resp) => {
      this.optServiceProviderCompany = [];
      
      if (resp.length != 0){
        this.optServiceProviderCompany = resp;
        this.filteredOptions$ = of(this.optServiceProviderCompany);
      }
    })
  };

  ngAfterViewInit() {
    setTimeout(() => {
      this.autoInput.nativeElement.blur();
    });
  }

  private filter(value: string): string[] {
    console.log(value);
    const filterValue = value.toLowerCase();
    return this.optServiceProviderCompany.filter(optionValue => optionValue.toLowerCase().includes(filterValue));
  }

  getFilteredOptions(value: string): Observable<string[]> {
    return of(value).pipe(
      map(filterString => this.filter(filterString)),
    );
  }

  onChange(event: string) {
    this.filteredOptions$ = this.getFilteredOptions(event);
    let inputValue = event;
    let inputValueUppCase = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
    this.spcSelected.emit(inputValueUppCase);
  }

  onSelectionChange(event: string) {
    this.spcSelected.emit(event);
  }

}
